import { Grid, Typography } from '@mui/material';
import { memo } from 'react';

import {
  convertDryAreaFloorFinish,
  convertWetAreaFloorFinish,
  convertWetAreaWallFinish,
} from '../../../api/characteristics/enumerations';
import {
  SectionStatus,
  WetAndDryAreas,
} from '../../../api/characteristics/types';
import { SectionStatusBadge } from '../components/StatusIndicators';
import { AnswerTag, AnswerTagsBox, StyledDivider } from '../styles';

interface ApartmentWetAndDryAreasSectionProps {
  formData: WetAndDryAreas;
  sectionStatus?: SectionStatus;
}

export const ApartmentWetAndDryAreasSection = memo(
  function ApartmentWetAndDryAreasSection({
    formData,
    sectionStatus,
  }: ApartmentWetAndDryAreasSectionProps) {
    return (
      <Grid container spacing={2} marginBottom={3}>
        <Grid item xs={12}>
          <SectionStatusBadge status={sectionStatus} />
        </Grid>
        <Grid item xs={12}>
          <Typography
            fontSize={18}
            fontWeight={600}
            id="wet-dry-areas-molhadas"
          >
            Áreas Molhadas
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography fontWeight={600}>Pisos</Typography>
        </Grid>
        <Grid item xs={12}>
          <AnswerTagsBox>
            {formData.wet_areas.floors.length > 0 ? (
              formData.wet_areas.floors.map((v) => (
                <AnswerTag key={v}>{convertWetAreaFloorFinish(v)}</AnswerTag>
              ))
            ) : (
              <Typography>-</Typography>
            )}
            {formData.wet_areas.floors_other && (
              <AnswerTag>{formData.wet_areas.floors_other}</AnswerTag>
            )}
          </AnswerTagsBox>
        </Grid>
        <Grid item xs={12} mt={2}>
          <Typography fontWeight={600}>Paredes</Typography>
        </Grid>
        <Grid item xs={12}>
          <AnswerTagsBox>
            {formData.wet_areas.walls.length > 0 ? (
              formData.wet_areas.walls.map((v) => (
                <AnswerTag key={v}>{convertWetAreaWallFinish(v)}</AnswerTag>
              ))
            ) : (
              <Typography>-</Typography>
            )}
            {formData.wet_areas.walls_other && (
              <AnswerTag>{formData.wet_areas.walls_other}</AnswerTag>
            )}
          </AnswerTagsBox>
        </Grid>

        <Grid item xs={12}>
          <StyledDivider />
        </Grid>
        <Grid item xs={12}>
          <Typography fontSize={18} fontWeight={600} id="wet-dry-areas-secas">
            Áreas Secas
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography fontWeight={600}>Pisos</Typography>
        </Grid>
        <Grid item xs={12}>
          <AnswerTagsBox>
            {formData.dry_areas.floors.length > 0 ? (
              formData.dry_areas.floors.map((v) => (
                <AnswerTag key={v}>{convertDryAreaFloorFinish(v)}</AnswerTag>
              ))
            ) : (
              <Typography>-</Typography>
            )}
            {formData.dry_areas.floors_other && (
              <AnswerTag>{formData.dry_areas.floors_other}</AnswerTag>
            )}
          </AnswerTagsBox>
        </Grid>
      </Grid>
    );
  }
);
